module.exports = __webpack_public_path__ + "img/icon-challenges.1cfa3b0e.svg";